import NextImage from "src/common/NextImage"

function CollaborateIllustration() {
  return (
    <NextImage
      src='/images/projectlink-collaborate.svg'
      dimensions={[347, 190]}
    />
  )
}

export default CollaborateIllustration
